(function () {
  if (window.__fpBrandFinderBound) return;
  window.__fpBrandFinderBound = true;

  var STORAGE_KEY = 'fpVehicleSelection';
  var ARROW =
    '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 8h11M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var cache = new WeakMap();
  var logoCache = new WeakMap();

  function parseJson(text) {
    var raw = String(text || '').trim();
    var start = raw.indexOf('{');
    var end = raw.lastIndexOf('}');
    if (start === -1 || end === -1) return { brands: [] };
    return JSON.parse(raw.slice(start, end + 1));
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var navIndex = null;

  /**
   * The brands, models and exact product for each cover, from
   * assets/fp-nav-index.json: built from the published products by
   * scripts/build_filter_index.py and shared with the header menu. (The
   * finder used to read assets/fp-catalog.json, a September list that
   * guessed product addresses and sent some models to hidden products.)
   */
  function loadIndex(root) {
    if (!navIndex) {
      navIndex = fetch(root.getAttribute('data-index') || '')
        .then(function (response) {
          return response.ok ? response.json() : {};
        })
        .catch(function () {
          // Allow another click to retry a failed request.
          navIndex = null;
          return {};
        });
    }
    return navIndex.then(function (index) {
      if (cache.get(root) || !Object.keys(index).length) return;
      var data = {};
      Object.keys(index).forEach(function (key) {
        data[key] = (index[key].brands || []).map(function (entry) {
          var covers = {};
          var handles = {};
          entry.models.forEach(function (model) {
            covers[model.l] = coverKeys(key, model.c);
            handles[model.l] = model.c;
          });
          return {
            brand: entry.brand,
            models: entry.models.map(function (model) {
              return model.l;
            }),
            covers: covers,
            handles: handles,
          };
        });
      });
      cache.set(root, data);
    });
  }

  /** A model's covers in finder order. As in the header menu, a van's driver cover also fits a single passenger seat. */
  function coverKeys(catalog, c) {
    var keys = ['high', 'low', 'driver', 'passenger', 'double-passenger'].filter(function (key) {
      return c[key];
    });
    if (catalog === 'vans' && c.driver && c['double-passenger'] && !c.passenger) {
      keys.splice(keys.indexOf('driver') + 1, 0, 'single-passenger');
    }
    return keys;
  }

  function cataloguesFor(root) {
    return cache.get(root) || {};
  }

  function logosFor(root) {
    var stored = logoCache.get(root);
    if (stored) return stored;
    var data = { logos: {}, darkFace: [] };
    var script = root.querySelector('script[data-fp-brand-logos]');
    if (script) {
      try {
        var parsed = parseJson(script.textContent);
        if (parsed && parsed.logos) data.logos = parsed.logos;
        if (parsed && Array.isArray(parsed.darkFace)) data.darkFace = parsed.darkFace;
      } catch (error) {
        console.warn('[fp-brand-finder] Could not parse brand logos', error);
      }
    }
    logoCache.set(root, data);
    return data;
  }

  // Initials for brands with no logo file yet, so the plate still reads as a
  // deliberate mark rather than an empty box.
  function monogram(brand) {
    var words = String(brand)
      // Fold accents first, otherwise "Schäffer" splits into "Sch" + "ffer".
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^A-Za-z0-9\s-]/g, ' ')
      .split(/[\s-]+/)
      .filter(Boolean);
    if (!words.length) return '';
    if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
    return (words[0][0] + words[1][0]).toUpperCase();
  }

  function logoMarkup(root, brand, variant) {
    var data = logosFor(root);
    var src = data.logos[brand];
    var cls = 'fp-brand-mark' + (variant ? ' fp-brand-mark--' + variant : '');
    // Chrome and white marks (Foden's badge, for one) vanish on the white face.
    if (src && data.darkFace.indexOf(brand) !== -1) cls += ' fp-brand-mark--dark';
    if (src) {
      // Brand cards are only built after a click, so they are always on screen:
      // lazy loading there buys nothing and just makes the marks pop in. Model
      // lists can run to 39 cards, so those inline marks stay lazy.
      var loading = variant === 'card' ? 'eager' : 'lazy';
      return (
        '<span class="' +
        cls +
        '"><img src="' +
        escapeHtml(src) +
        '" alt="' +
        escapeHtml(brand) +
        ' logo" loading="' +
        loading +
        '" decoding="async"></span>'
      );
    }
    return (
      '<span class="' +
      cls +
      ' fp-brand-mark--text" aria-hidden="true">' +
      escapeHtml(monogram(brand)) +
      '</span>'
    );
  }

  function handleize(value) {
    return String(value)
      .normalize('NFKD')
      .replace(/[^\x00-\x7F]/g, '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/\+/g, 'plus')
      .replace(/\//g, ' ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function brandEntry(root, catalog, brand) {
    var brands = cataloguesFor(root)[catalog] || [];
    return brands.filter(function (item) {
      return item.brand === brand;
    })[0];
  }

  function coversFor(catalog, entry, model) {
    var mapped = entry && entry.covers && entry.covers[model];
    if (Array.isArray(mapped) && mapped.length) return mapped;
    if (catalog === 'lorries') return ['high'];
    if (catalog === 'pickups') return ['driver', 'passenger'];
    if (catalog === 'vans') return ['driver', 'double-passenger'];
    return ['high', 'low'];
  }

  function fitForCover(catalog, cover) {
    if (catalog === 'pickups' || catalog === 'vans') {
      if (String(cover).indexOf('double') !== -1) return 'Double Passenger';
      if (cover === 'single-passenger') return 'Single Passenger';
      if (String(cover).indexOf('passenger') !== -1) return 'Passenger';
      return 'Driver';
    }
    return cover === 'low' ? 'Low Back' : 'High Back';
  }

  function allFitOptions(catalog) {
    if (catalog === 'pickups') {
      return [
        { label: 'Driver cover', fit: 'Driver', meta: 'High-back driver seat', cover: 'driver' },
        { label: 'Passenger cover', fit: 'Passenger', meta: 'High-back passenger seat', cover: 'passenger' },
      ];
    }
    if (catalog === 'vans') {
      return [
        { label: 'Driver cover', fit: 'Driver', meta: 'High-back driver seat', cover: 'driver' },
        { label: 'Single passenger cover', fit: 'Single Passenger', meta: 'High-back single passenger seat', cover: 'single-passenger' },
        { label: 'Passenger cover', fit: 'Passenger', meta: 'High-back passenger seat', cover: 'passenger' },
        { label: 'Double passenger cover', fit: 'Double Passenger', meta: 'High-back double passenger seat', cover: 'double-passenger' },
      ];
    }
    return [
      { label: 'High-back cover', fit: 'High Back', meta: 'High-back seat', cover: 'high' },
      { label: 'Low-back cover', fit: 'Low Back', meta: 'Low-back seat', cover: 'low' },
    ];
  }

  function fitsFor(catalog, covers) {
    var allowed = covers && covers.length ? covers : null;
    return allFitOptions(catalog).filter(function (option) {
      return !allowed || allowed.indexOf(option.cover) !== -1;
    });
  }

  function hrefFor(root, brand, model, cover) {
    var entry = brandEntry(root, root.getAttribute('data-catalog') || '', brand);
    var handles = entry && entry.handles && entry.handles[model];
    if (handles) {
      // The single passenger cover is the driver product, marked so
      // assets/fp-companion-seat.js labels the line "Seat: Single passenger".
      if (cover === 'single-passenger' && handles.driver) return '/products/' + handles.driver + '?seat=single-passenger';
      if (handles[cover]) return '/products/' + handles[cover];
    }
    // No product for that cover: the collection, filtered by the brand.
    var url = root.getAttribute('data-product-url') || '';
    if (!url) return '#';
    var next = new URL(url, window.location.origin);
    if (next.pathname.indexOf('/collections/') !== -1) {
      var base = next.pathname.replace(/\/$/, '');
      return brand ? base + '/' + handleize(brand) : base;
    }
    return next.pathname;
  }

  function remember(brand, model, catalog, fit) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ brand: brand, model: model, catalog: catalog, fit: fit || '' }));
    } catch (err) {
      /* ignore */
    }
  }

  function play(grid) {
    grid.classList.remove('is-playing');
    void grid.offsetWidth;
    grid.classList.add('is-playing');
  }

  function setStep(root, step) {
    root.setAttribute('data-step', step);
    root.querySelectorAll('.fp-brand-finder__view').forEach(function (view) {
      var on = view.getAttribute('data-view') === step;
      view.classList.toggle('is-active', on);
      if (on) view.removeAttribute('hidden');
      else view.setAttribute('hidden', '');
    });
  }

  function renderBrands(root) {
    var grid = root.querySelector('[data-fp-grid="brands"]');
    if (!grid) return;
    var catalog = root.getAttribute('data-catalog') || '';
    var brands = cataloguesFor(root)[catalog] || [];
    var heading = root.querySelector('[data-fp-brands-heading]');
    var backBrands = root.querySelector('[data-fp-back-brands]');
    var label = root.getAttribute('data-label') || 'Brands';
    if (heading) heading.textContent = label;
    if (backBrands) backBrands.textContent = label;
    grid.innerHTML = '';
    brands.forEach(function (entry, index) {
      var count = (entry.models || []).length;
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'fp-finder-card';
      card.setAttribute('data-brand', entry.brand);
      card.style.setProperty('--fp-card-delay', Math.min(index, 18) * 24 + 'ms');
      card.innerHTML =
        logoMarkup(root, entry.brand, 'card') +
        '<span class="fp-finder-card__name">' +
        escapeHtml(entry.brand) +
        '</span><span class="fp-finder-card__meta">' +
        count +
        ' model ' +
        (count === 1 ? 'family' : 'families') +
        '</span><span class="fp-finder-card__cta">View models ' +
        ARROW +
        '</span>';
      grid.appendChild(card);
    });
    play(grid);
  }

  function renderModels(root) {
    var grid = root.querySelector('[data-fp-grid="models"]');
    if (!grid) return;
    var catalog = root.getAttribute('data-catalog') || '';
    var brand = root.getAttribute('data-brand') || '';
    var heading = root.querySelector('[data-fp-models-heading]');
    var entry = brandEntry(root, catalog, brand);
    var models = entry && entry.models ? entry.models : [];
    if (heading) heading.textContent = brand;

    var brandmark = root.querySelector('[data-fp-models-brandmark]');
    if (brandmark) {
      brandmark.innerHTML = logoMarkup(root, brand, 'header');
      brandmark.removeAttribute('hidden');
    }

    grid.innerHTML = '';
    models.forEach(function (model, index) {
      var covers = coversFor(catalog, entry, model);
      var chooseFit = covers.length > 1;
      var card = document.createElement(chooseFit ? 'button' : 'a');
      card.className = 'fp-finder-card fp-finder-card--model';
      if (chooseFit) card.type = 'button';
      else card.href = hrefFor(root, brand, model, covers[0]);
      card.setAttribute('data-model', model);
      card.style.setProperty('--fp-card-delay', Math.min(index, 18) * 20 + 'ms');
      card.innerHTML =
        logoMarkup(root, brand, 'card') +
        '<span class="fp-finder-card__name">' +
        escapeHtml(model) +
        '</span><span class="fp-finder-card__meta">' +
        escapeHtml(brand) +
        '</span><span class="fp-finder-card__cta">' +
        (chooseFit ? 'Choose fit ' : 'Shop this cover ') +
        ARROW +
        '</span>';
      grid.appendChild(card);
    });
    play(grid);
  }

  var fitImageCache = null;

  /** Hero photo per catalogue and cover shape, emitted by the section. */
  function fitImagesFor(root) {
    if (fitImageCache) return fitImageCache;
    fitImageCache = {};
    var node = root.querySelector('[data-fp-fit-images]');
    if (node) {
      try {
        fitImageCache = JSON.parse(node.textContent) || {};
      } catch (error) {
        fitImageCache = {};
      }
    }
    return fitImageCache;
  }

  function fitMediaMarkup(root, catalog, option) {
    var src = fitImagesFor(root)[catalog + '|' + option.cover];
    if (!src) return '';
    // The fit step is short and always on screen by the time it is built, so
    // these load eagerly rather than popping in under the customer's cursor.
    return (
      '<span class="fp-finder-card__media"><img src="' +
      escapeHtml(src) +
      '" alt="' +
      escapeHtml(option.meta) +
      '" loading="eager" decoding="async"></span>'
    );
  }

  function renderFits(root) {
    var grid = root.querySelector('[data-fp-grid="fits"]');
    if (!grid) return;
    var catalog = root.getAttribute('data-catalog') || '';
    var brand = root.getAttribute('data-brand') || '';
    var model = root.getAttribute('data-model') || '';
    var heading = root.querySelector('[data-fp-fits-heading]');
    var backModels = root.querySelector('[data-fp-back-models]');
    var brandmark = root.querySelector('[data-fp-fits-brandmark]');
    if (heading) heading.textContent = model;
    if (backModels) backModels.textContent = brand || 'All models';
    if (brandmark) {
      brandmark.innerHTML = logoMarkup(root, brand, 'header');
      brandmark.removeAttribute('hidden');
    }
    grid.innerHTML = '';
    var entry = brandEntry(root, catalog, brand);
    var covers = coversFor(catalog, entry, model);
    fitsFor(catalog, covers).forEach(function (option, index) {
      var card = document.createElement('a');
      card.className = 'fp-finder-card fp-finder-card--fit';
      card.href = hrefFor(root, brand, model, option.cover);
      card.setAttribute('data-fit', option.fit);
      card.style.setProperty('--fp-card-delay', index * 40 + 'ms');
      card.innerHTML =
        fitMediaMarkup(root, catalog, option) +
        logoMarkup(root, brand, 'card') +
        '<span class="fp-finder-card__name">' +
        escapeHtml(option.label) +
        '</span><span class="fp-finder-card__meta">' +
        escapeHtml(brand + ' · ' + model) +
        '</span><span class="fp-finder-card__cta">Shop this cover ' +
        ARROW +
        '</span>';
      grid.appendChild(card);
    });
    play(grid);
  }

  document.addEventListener('click', async function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var cat = target.closest('.fp-finder-cat');
    if (cat) {
      var root = cat.closest('.fp-brand-finder');
      if (!root) return;
      event.preventDefault();
      cat.setAttribute('aria-busy', 'true');
      await loadIndex(root);
      cat.removeAttribute('aria-busy');
      if (!root.isConnected) return;
      root.setAttribute('data-catalog', cat.getAttribute('data-catalog') || '');
      root.setAttribute('data-product-url', cat.getAttribute('data-product-url') || '');
      root.setAttribute('data-label', cat.getAttribute('data-label') || 'Brands');
      root.removeAttribute('data-brand');
      root.removeAttribute('data-model');
      renderBrands(root);
      setStep(root, 'brands');
      return;
    }

    var back = target.closest('[data-fp-back]');
    if (back) {
      var backRoot = back.closest('.fp-brand-finder');
      if (!backRoot) return;
      event.preventDefault();
      var dest = back.getAttribute('data-fp-back');
      if (dest === 'categories') {
        backRoot.removeAttribute('data-brand');
        backRoot.removeAttribute('data-model');
        setStep(backRoot, 'categories');
      } else if (dest === 'models') {
        backRoot.removeAttribute('data-model');
        renderModels(backRoot);
        setStep(backRoot, 'models');
      } else {
        backRoot.removeAttribute('data-brand');
        backRoot.removeAttribute('data-model');
        renderBrands(backRoot);
        setStep(backRoot, 'brands');
      }
      return;
    }

    var brandCard = target.closest('.fp-finder-grid--brands [data-brand]');
    if (brandCard) {
      var brandRoot = brandCard.closest('.fp-brand-finder');
      if (!brandRoot) return;
      event.preventDefault();
      var brand = brandCard.getAttribute('data-brand') || '';
      if (!brand) return;
      brandRoot.setAttribute('data-brand', brand);
      brandRoot.removeAttribute('data-model');
      renderModels(brandRoot);
      setStep(brandRoot, 'models');
      return;
    }

    var modelCard = target.closest('.fp-finder-card[data-model]');
    if (modelCard && modelCard.closest('.fp-brand-finder')) {
      var modelRoot = modelCard.closest('.fp-brand-finder');
      var brandName = modelRoot.getAttribute('data-brand') || '';
      var modelName = modelCard.getAttribute('data-model') || '';
      var catalog = modelRoot.getAttribute('data-catalog') || '';
      if (!brandName) return;
      var covers = coversFor(catalog, brandEntry(modelRoot, catalog, brandName), modelName);
      if (covers.length > 1) {
        event.preventDefault();
        modelRoot.setAttribute('data-model', modelName);
        renderFits(modelRoot);
        setStep(modelRoot, 'fits');
        return;
      }
      remember(brandName, modelName, catalog, fitForCover(catalog, covers[0]));
      return;
    }

    var fitCard = target.closest('.fp-finder-card[data-fit]');
    if (fitCard && fitCard.closest('.fp-brand-finder')) {
      var fitRoot = fitCard.closest('.fp-brand-finder');
      remember(
        fitRoot.getAttribute('data-brand') || '',
        fitRoot.getAttribute('data-model') || '',
        fitRoot.getAttribute('data-catalog') || '',
        fitCard.getAttribute('data-fit') || ''
      );
    }
  });
})();
